<footer class="footer mt-5">
		<div class="container-fluid" style="text-align: right">
			<span style="color: #c6c5c5; font-size: 14px;">All Rights Reserved @ My Fortress</span>
		</div>
	</footer>